/** @jsx jsx */
import { css } from '@emotion/core';

const styles = {
  link: css`
    text-decoration: none;
  `,
};

export default styles;
